import { useField } from "formik";
import React, { FC } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import style from "./style.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import { de } from "date-fns/locale";
import validationError from "../../assets/images/validationError.svg";

registerLocale("de", de);

const MONTH_NAMES_DE = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
];

const DEFAULT_YEAR_OFFSET = 5;

interface ICustomDatePicker {
  name: string;
  type: string;
  label: string;
  placeholder?: string;
  hasFullWidth?: boolean;
  marginBottom?: string;
  width?: string;
  onClick?: (data: any) => void;
  withPreselectedDate?: boolean;
  withDateRange?: boolean;
  showMonthYearPicker?: boolean;
  disableInput?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

export const CustomDatePicker: FC<ICustomDatePicker> = ({
  label,
  name,
  type,
  hasFullWidth,
  marginBottom,
  placeholder,
  width,
  onClick,
  withPreselectedDate = true,
  withDateRange = false,
  showMonthYearPicker = false,
  disableInput = false,
  minDate,
  maxDate,
}) => {
  const [field, meta, helpers] = useField({
    name,
    type,
  });

  const wrapperStyle = {
    marginBottom: marginBottom ? `${marginBottom}px` : "",
    width: width?.includes("%")
      ? `${width}`
      : width && !width?.includes("%")
        ? `${width}px`
        : "",
  };

  const hasError = meta.touched && meta.error;
  const isEmpty = !field.value?.length;

  return (
    <div
      className={`${style.input_wrapper} ${
        hasFullWidth && style.fullWidthInput
      } ${hasError && style.input_wrapperWithWarning}`}
      style={wrapperStyle}
    >
      <label
        className={`${style.label} ${hasError ? style.labelWithWarning : ""}`}
        htmlFor={name}
      >
        {label}
      </label>
      <DatePicker
        // showIcon={true}
        id={name}
        selected={
          field.value
            ? new Date(field.value)
            : withPreselectedDate
              ? new Date()
              : null
        }
        onChange={(date) => {
          if (date) {
            if (onClick) {
              onClick(
                withDateRange ? date : new Date(date as Date).toISOString(),
              );
            }
            helpers.setValue(new Date(date as Date).toISOString());
          }
        }}
        selectsRange={withDateRange}
        className={`${style.customInput} ${
          hasError ? style.customInputWithWarning : ""
        }`}
        locale={"de"}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder}
        showMonthYearPicker={showMonthYearPicker}
        onKeyDown={(e) => {
          if (disableInput) e.preventDefault();
        }}
        minDate={minDate}
        maxDate={maxDate}
      />
      {/* {meta.touched && meta.error && !field.value.length && ( */}
      <div
        className={`${style.errorMessage} ${
          hasError && isEmpty ? "" : style.disabledErrorMessage
        }`}
      >
        {meta.error}
      </div>
      {/* )} */}
      {/* {meta.touched && meta.error && !field.value.length && ( */}
      <img
        src={validationError}
        alt="err"
        className={`${style.warningImg} ${style.warningImgWithSelect} ${
          hasError && isEmpty ? "" : style.disabledErrorMessage
        }`}
      />
      {/* )} */}
    </div>
  );
};
